import validationSystemServices from '@mortee/services/validationSystemServices';
import { SupplierValidationDocument, transformSupplierValidationDocument } from '@mortee/domain/validationSystem';
import { HttpStatus, isRequestError } from '@app/libs/request';

// A record that never had a document submission answers 404 rather than an empty list.
export async function loadValidationRecordDocuments(validationRecordStaticId: string): Promise<SupplierValidationDocument[]> {
  try {
    const serverResponse = await validationSystemServices.getValidationRecordDocuments(validationRecordStaticId);
    return serverResponse.map(transformSupplierValidationDocument);
  } catch (error) {
    if (isRequestError(error) && error.code === HttpStatus.notFound) {
      return [];
    }
    throw error;
  }
}
